import { getDevFlags } from "@utils/dev-flags";
import logger from "@utils/logger";

export const getNotificationDrawerEnabled = async (): Promise<boolean> => {
  const isLocalEnabled = getDevFlags()?.notificationDrawerEnabled;
  if (isLocalEnabled !== null && isLocalEnabled !== undefined) {
    logger._console.log("[Config] Using dev flag for notification drawer", { isLocalEnabled });
    return Boolean(isLocalEnabled);
  }
  logger._console.log("[Config] Notification drawer enabled by default");
  return true;
};
